import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { TwoFactorIconComponent } from "@bitwarden/angular/auth/components/two-factor-icon.component";
import { TwoFactorProviderType } from "@bitwarden/common/auth/enums/two-factor-provider-type";

@Component({
  selector: "app-bv-two-factor-provider-icon",
  templateUrl: "./bv-two-factor-provider-icon.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "bv-two-factor-provider-icon-host",
  },
  imports: [TwoFactorIconComponent],
})
export class BvTwoFactorProviderIconComponent {
  readonly provider = input.required<TwoFactorProviderType>();
  readonly name = input<string>();

  protected readonly customIconSrc = computed(() => {
    switch (this.provider()) {
      case TwoFactorProviderType.Email:
        return "images/icons/brackets-vault/Email.svg";
      case TwoFactorProviderType.Authenticator:
        return "images/icons/brackets-vault/MobileAuthentication.svg";
      case TwoFactorProviderType.WebAuthn:
        return "images/icons/brackets-vault/securityways.svg";
      default:
        return null;
    }
  });
}
